/* eslint-disable */

export { default as NotificationLoader } from './NotificationLoader.vue'
export { default as MarketLoader } from './MarketLoader.vue'
export { default as MarketSharesItemLoader } from './MarketSharesItemLoader.vue'
export { default as MarketWidgetLoader } from './MarketWidgetLoader.vue'
export { default as BiggestGainsLoader } from './BiggestGainsLoader.vue'
export { default as TableRowsLoader } from './TableRowsLoader.vue'
export { default as AccountWithdrawalLoader } from './AccountWithdrawalLoader.vue'
export { default as AccountFormLoader } from './AccountFormLoader.vue'
export { default as LeaderboardsInfoLoader } from './LeaderboardsInfoLoader.vue';
export { default as OverviewMapLoader } from './OverviewMapLoader.vue';
export { default as MarketChartLoader } from './MarketChartLoader.vue'
export { default as StaticPageLoader } from './StaticPageLoader.vue';
export { default as PreviewCarouselLoader } from './PreviewCarouselLoader.vue';
export { default as MarketDetailPageLoader } from './MarketDetailPageLoader.vue';
export { default as SocialsLoader } from './SocialsLoader.vue';
export { default as ContractInfoLoader } from './ContractInfoLoader.vue'



// WEBPACK FOOTER //
// ./src/components/content-loader/index.js